<template>
  <div id="manage">
    <div class="content">
        <div class="title">承办单位管理</div>
        <div class="top">
            <div class="fl_left">
                <div class="wzbarBox">
                    <div class="wzbar" v-for="(name,index) in items" @click="tab(index,name)" :class="{'wzbars':index==num}">
                        <div>{{name.name}}</div>
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <span>共</span><span style="font-size:18px;color:#c30d23;">{{total}}</span><span>家</span>
                    </div>
                    <div class="fl_left">
                        <Select v-model="searchModel.country_id" @on-change="getCompanyList(1)" class="bordiv" clearable placeholder="请选择国家" filterable style="width:150px;margin:20px 0 20px 15px;">
                            <Option v-for="item in countryList" :key="item.id" :value="item.id" >{{ item.country}}</Option>
                        </Select>
                        <Select v-if="searchModel.country_id=='754a7162vx84bd6v92c1'||searchModel.country_id=='ac925162vx84bd6v898e'" clearable v-model="searchModel.province_id" placeholder="请选择省份" class="borDiv" style="width:150px;border:1px solid #e7e7eb;margin:20px 15px;" @on-change="getCompanyList(1)">
                            <Option v-for="item in provinceArr" :value="item.id" :key="item.id">{{ item.province }}</Option>
                        </Select>
                        <Select v-model="searchModel.type_id" @on-change="getCompanyList(1)" class="bordiv" placeholder="请选择承办单位类型" clearable filterable style="width:180px;margin:20px 15px;">
                            <Option v-for="item in companyTypeList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                        </Select>
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input 
                        id="demo" 
                        v-model="searchModel.keyword" 
                        icon="ios-search" 
                        placeholder="承办单位名称搜索" 
                        style="width: 200px;height:34px;border:1px solid #e7e7eb;margin:20px 0;" 
                        class="bradius" 
                        @on-click="getCompanyList(1)" 
                        @keyup.enter.native="getCompanyList(1)" 
                        autocomplete="off"></Input>
                    </div>
                    <div class="fl_right addClass" @click="addCompany" v-if="searchModel.is_stop==0">新增承办单位</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                    <Page :page-size="pageSize" :total="total" show-total :current="searchModel.page" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
                </div>
            </div>
            <!-- 添加 -->
            <div class="alertBox" v-if="alertShow" style="padding-top:3%;">
                <div class="tanchuan" style="width:780px;overflow:hidden;">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div style="height:80vh;">
                        <div class="tancenter" style="overflow-y:auto;height: 100%;padding-bottom: 30px;">
                            <div class="list listpad">
                                <div class="fl_left name">承办单位类型<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Select v-model="addCompanyModel.type_id" class="bordiv" placeholder="请选择承办单位类型" filterable style="width:440px;margin-right:10px;height:36px;margin-bottom:10px;">
                                     <Option v-for="item in companyTypeList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                    </Select>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">{{type_str}}名称<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Input v-model="addCompanyModel.name" class="bordiv" size="large" autocomplete="off" style="width:440px;" :placeholder="'请输入'+type_str+'名称'" />
                                    <input type="text"  autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad" v-show="numberShow">
                                <div class="fl_left name">{{type_str}}编号
                                    <span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Input v-model="addCompanyModel.number" class="bordiv" size="large" autocomplete="off" style="width:440px;" :placeholder="'请输入'+ type_str +'编号'" />
                                    <input type="text"  autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad" v-show="starShow">
                                <div class="fl_left name">星级</div>
                                <div class="fl_left inputBox">
                                    <Select v-model="addCompanyModel.star_id" class="bordiv" placeholder="请选择星级" filterable style="width:440px;margin-right:10px;height:36px;margin-bottom:10px;">
                                     <Option v-for="item in starList" :key="item.id" :value="item.id" >{{item.star}}</Option>
                                    </Select>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">所在国家<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Select v-model="addCompanyModel.country_id" class="bordiv" placeholder="请选择" filterable style="width:440px;margin-right:10px;height:36px;margin-bottom:10px;">
                                     <Option v-for="item in countryList" :key="item.id" :value="item.id" >{{ item.country}}</Option>
                                    </Select>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">{{addCompanyModel.country_id=='754a7162vx84bd6v92c1'?'所在城市':'详细地址'}}<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Select v-model="addCompanyModel.province_id" class="bordiv" placeholder="请选择省份" filterable @on-change="getCityList" style="width:167px;margin-right:10px;height:36px;margin-bottom:10px;" v-if="addCompanyModel.country_id=='754a7162vx84bd6v92c1'">
                                     <Option v-for="item in provinceArr" :key="item.id" :value="item.id" >{{ item.province}}</Option>
                                    </Select>
                                    <Select v-model="addCompanyModel.city_id" multiple class="bordiv" placeholder="请选择城市" filterable style="width:440px;height:108px;margin-bottom:20px;" not-found-text="请先选择省份" v-if="addCompanyModel.country_id=='754a7162vx84bd6v92c1'">
                                      <Option v-for="item in cities" :key="item.id" :value="item.id" >{{ item.city}}</Option>
                                    </Select>
                                    <Input v-model="addCompanyModel.address" class="bordiv" size="large" style="width:440px;" placeholder="详细地址" />
                                    <input type="text" autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">承办Logo</div>
                                <div class="fl_left inputBox">
                                    <div class="file-list">
                                        <!-- <section class="file-item draggable-item" v-if="logo">
                                            <img :src="logo" alt="" ondragstart="return false;" >
                                        </section>
                                        <section v-else class="file-item>
                                            <div class="add"></div>
                                        </section> -->
                                        <div class="urlLogo urlLogo1" >
                                            <img :src="imgd1" alt="" v-if="imgd1">
                                            <div class="add" v-else></div>
                                            <!-- <img src="static/imgs/up_zjz.png" alt="" v-if="!imgd1"> -->
                                            <input type="file" id="file1" multiple="false" @change="doUpload(1)"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">联系人<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Input v-model="addCompanyModel.linkman" class="bordiv" size="large" style="width:167px;margin-right: 7px;" placeholder="姓名" />
                                    <Input v-model="addCompanyModel.linkphone" class="bordiv" size="large" style="width:263px;" placeholder="手机号" />
                                    <input type="text" autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad" v-show="starShow">
                                <div class="fl_left name">邮箱</div>
                                <div class="fl_left inputBox">
                                    <Input v-model="addCompanyModel.email" class="bordiv" size="large" style="width:440px;" placeholder="邮箱" />
                                    <input type="text" autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="tanBtn" @click="saveCompany">确定</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 裁剪 -->
            <div class="alertBox" v-show="cropShow" style="padding-top: 8%">
                <div style="background: #fff;width: 600px;height: 445px;margin:0 auto;
                padding-top: 20px;">
                    <div class="cropper">
                        <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :fixedBox="option.fixedBox"
                        >
                        </vueCropper>
                    </div>
                    <div style="width: 300px;margin: 0 auto;">
                        <div class="fl_left tanBtn tanBtned tanBtneds" @click="delCrop">取消</div>
                        <div class="fl_right tanBtn tanBtneds" @click="upload('base64')">确认裁剪</div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
            <div class="alertBox" v-if="setShow">
                <div class="tanchuan" style="width:780px;overflow:hidden;">
                    <div class="tantop">
                        <div class="fl_left tantitle">设置承办单位</div>
                        <div class="fl_right tandel" @click="setShow=false"></div>
                        <div class="clear"></div>
                    </div>
                    <div>
                        <div class="tancenter" style="overflow-y:auto;height: 100%;padding-bottom: 30px;">
                            <div class="list listpad">
                                <div class="fl_left name">是否停用</div>
                                <div class="fl_left inputBox">
                                    <i-switch v-model="is_stop" @on-change="tychange" />
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad" v-if="is_stop">
                                <div class="fl_left name">停用原因</div>
                                <div class="fl_left inputBox">
                                    {{stop_reason}}
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">是否在线收费</div>
                                <div class="fl_left inputBox">
                                    <i-switch v-model="is_pay" @on-change="sfchange" />
                                    <div style="font-size:12px;color:#c30d23;line-height:20px;">打开在线收费，则考生在APP报名的时候，需要在线收费，适用于自营培训或合作办学点。未打开，则需要承办单位线下收费，线下确认。</div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <!-- <div class="tanBtn" @click="tysure">确定</div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 设置分成比例 -->
            <div class="alertBox" v-if="setBfb">
                <div class="tanchuan" style="width:600px;overflow:hidden;">
                    <div class="tantop">
                        <div class="fl_left tantitle">设置分成比例</div>
                        <div class="fl_right tandel" @click="setBfb=false"></div>
                        <div class="clear"></div>
                    </div>
                    <div>
                        <div class="tancenter" style="overflow-y:auto;height: 100%;padding-bottom: 30px;">
                            <div class="list listpad">
                                <div class="fl_left name">手机号</div>
                                <div class="fl_left inputBox" style="width:380px;">
                                    <Input v-model="keyphone" placeholder="请输入手机号" class="borDiv" disabled></Input>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">验证码</div>
                                <div class="fl_left inputBox" style="position: relative;width:390px;">
                                    <Input v-model="smscode" class="borDiv" placeholder="请输入验证码"></Input>
                                    <button @click="handCoded" class="codeBtn" :disabled="!codeShowd">
                                       <span v-if="codeShowd">获取验证码</span>
                                       <span v-else class="count">{{countsd}} s</span>
                                    </button>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">分成比例</div>
                                <div class="fl_left inputBox" style="width:380px;">
                                    <Input v-model="rate" placeholder="请输入分成比例" class="borDiv" type="number" maxlength="5" search enter-button="%" ></Input>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="tanBtn" @click="setBfbBtn">确定</div>
                            <div class="list listpad">
                                <el-table :data="rateHistory" style="width: 100%">
                                    <el-table-column type="index" label="序号"></el-table-column>
                                    <el-table-column prop="rate" label="分成"></el-table-column>
                                    <el-table-column prop="name" label="设置人"></el-table-column>
                                    <el-table-column prop="change_time" label="修改时间"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 财务明细 -->
        <el-dialog :title="company_name" :visible.sync="dialogTableVisible" width="70%">
            <el-date-picker
                style="width:400px;"
                v-model="dateList"
                :clearable="true"
                type="daterange"
                @change="updateIncomePage(1)"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-table :data="incomeList" style="border:1px solid #EBEEF5;margin-top:20px">
                <el-table-column type="index" align="center"></el-table-column>
                <el-table-column property="name" label="购买老师" align="center"></el-table-column>
                <el-table-column property="money" label="支付金额" align="center"></el-table-column>
                <el-table-column property="company_income" label="承办单位收益" align="center"></el-table-column>
                <el-table-column property="procedures" label="手续费" align="center"></el-table-column>
                <el-table-column property="manage_income" label="平台收益" align="center"></el-table-column>
                <el-table-column property="pay_time" label="支付时间" align="center"></el-table-column>
            </el-table>
            <Page :page-size="incomePageSize" :total="incomePageTotal" show-total :current="incomePageNum" @on-change="updateIncomePage" style="margin-top:20px"></Page>
        </el-dialog>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                //搜索model
                searchModel:{
                    province_id:"",
                    keyword:"",
                    page:1,
                    is_stop:0,
                    country_id:"754a7162vx84bd6v92c1",
                    type_id:'', //承办单位类型
                },
                //添加model
                addCompanyModel:{
                    company_id:"",
                    name:"",
                    province_id:'',
                    city_id:[],
                    address:'',
                    linkman:'',
                    linkphone:'',
                    email:'',
                    logo:'',
                    country_id:'754a7162vx84bd6v92c1',
                    type_id:'',
                    number:'',
                    star_id:'',
                },
                type_str:'承办单位',
                setBfb:false,
                rate:'',
                account:'',
                smscode:'',
                countsd:'',
                codeShowd:true,
                dialogTableVisible:false,
                gridDataId:'',
                gridData:[],
                dateList:['',''],
                setShow:false,
                imgd1:'',
                cropShow:false,
                starShow:true,
                numberShow:true,
                option: {
                    img: '',//剪切图片地址
                    size: 1,//输出图片压缩比默认为1
                    full: false,//输出截图是否缩放
                    outputType: 'jpg',//输出图片格式
                    canMove: true,//是否可以拖动图片
                    fixedBox: true,//是否固定截图大小
                    original: false,//上传图片按原始比例
                    canMoveBox: false,//是否可以拖动截图框
                    autoCrop: true,//是否自成截图框
                    // 只有自动截图开启 宽度高度才生效
                    autoCropWidth: 300,//截图框宽
                    autoCropHeight: 300,//截图框高
                    centerBox: false,//截图框能否超过图片
                    high: true//是否根据dpr输出高清图片
                },
                maxnum:'',
                provinceArr:[],
                cities:[],
                num:0,
                curRow:'',//当前行
                items:[
                    {
                        name:'承办单位',
                        type:0
                    },
                    {
                        name:'已停用',
                        type:1
                    },
                ],
                total:null,
                pageSize:10,
                loading:false,
                stop_reason:'',
                columns7: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '承办单位logo',
                        align: 'center',
                        key: 'logo',
                        render: (h, params) => {
                            return h('div',[
                                h('img',{
                                    style:{
                                        width:'70px',
                                    },
                                    domProps: {
                                        src:params.row.logo==''?'static/imgs/logo@3x.png':params.row.logo
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: '承办单位名称',
                        align: 'center',
                        key: 'name'
                    },
                    {
                        title: '星级',
                        align: 'center',
                        key: 'star',
                        render:(h,params)=>{
                            return h('div',params.row.star==''?'无':params.row.star);
                        }
                    },
                    {
                        title: '类型',
                        align: 'center',
                        key: 'type',
                        render:(h,params)=>{
                            return h('div',params.row.type==''?'--':params.row.type);
                        }
                    },
                    {
                        title: '国家城市',
                        align: 'center',
                        key: 'country',
                        render:(h,params)=>{
                            return h('div',
                            (params.row.country==''?'--':params.row.country+"/") +
                            (params.row.country=='中国'?(params.row.province+(params.row.city==''?'':'/')+params.row.city):params.row.address)
                            );
                        }
                    },
                    {
                        title: '师资培训班(点击查看)',
                        align: 'center',
                        key: 'class_count',
                        width:80,
                        render: (h, params) => {
                            return h('div', [
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                    },
                                    on: {
                                        click: () => {
                                            localStorage.setItem("luder", JSON.stringify(this.searchModel));
                                            this.$router.push({
                                                path:'/manager/company/company/oldclass',
                                                query:{
                                                    term_id:params.row.id,
                                                    name:params.row.name,
                                                }
                                            })
                                        }
                                    }
                                }, params.row.class_count),
                            ]);
                        }
                    },
                    {
                        title: '学生培训班(点击查看)',
                        align: 'center',
                        key: 'teacher_class_count',
                        width:80,
                        render: (h, params) => {
                            return h('div', [
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                    },
                                    on: {
                                        click: () => {
                                            localStorage.setItem("luder", JSON.stringify(this.searchModel));
                                            this.$router.push({
                                                path:'/manager/company/company/teacherClass',
                                                query:{
                                                    term_id:params.row.id,
                                                    name:params.row.name,
                                                }
                                            })
                                        }
                                    }
                                }, params.row.teacher_class_count),
                            ]);
                        }
                    },
                    
                    {
                        title: '联系方式',
                        align: 'center',
                        key: 'linkman',
                        render: (h, params) => {
                            return h('div', [
                                h('div', {}, params.row.linkman),
                                h('div', {}, params.row.linkphone),
                            ]);
                        }
                    },
                    {
                        title: '分成占比',
                        align: 'center',
                        key: 'rate',
                        render: (h, params) => {
                            let _str    = '设置分成';
                            if(params.row.rate > 0){
                                _str = params.row.rate;
                            }
                            return h('div', [
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                    },
                                    on: {
                                        click: () => {
                                            let _this=this;
                                            _this.company_id=params.row.id;
                                            _this.rate=params.row.rate;
                                            _this.setBfb=true;
                                            _this.smscode='';
                                            _this.curRow = params.row;
                                            _this.getRateHistory();
                                        }
                                    }
                                },_str),
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.is_pay=params.row.is_pay==1?true:false;
                                                _this.is_stop=params.row.is_stop==1?true:false;
                                                _this.stop_reason=params.row.stop_reason;
                                                _this.company_id=params.row.id;
                                                _this.setShow=true;
                                            }
                                        }
                                    }, '设置'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            margin:'0 10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.company_id = params.row.id;
                                                _this.addCompanyModel   = params.row;
                                                _this.imgd1             = params.row.logo;
                                                _this.valm          = 1;
                                                _this.getCityList();
                                            }
                                        }
                                    }, '编辑'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除？</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deletecompany',{company_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('删除成功');
                                                                _this.getCompanyList(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    }
                ],
                data6: [],
                alertShow:false,
                valm:0,
                company_id:'',
                company_name:'',
                clnum:1,
                countryList:[],
                is_pay:'',
                is_stop:'',
                keyphone:'',    //关键手机号
                rateHistory:[], //分成比例修改历史
                incomeList:[], //收益列表页码
                incomePageNum:1, //收益列表页码
                incomePageSize:10, //收益列表每页数量
                incomePageTotal:null, //收益列表总数

                companyTypeList:[], //承办单位类型列表
                starList:[], //星级列表
            }
        },
        methods:{
            //获取验证码
            getRateHistory(){
                let _this=this;
                _this.$axios.post('setconfighistory',{company_id:_this.company_id}).then(res=>{
                    if(res.data.code==200){
                        _this.rateHistory=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message)
                    }
                }).catch( function(response) {
                    console.log(response)
                });
            },
            //获取验证码
            handCoded(){
                let _this=this;
                _this.$axios.post('getsmscode',{phone:_this.keyphone}).then(res=>{
                    if(res.data.code==200){
                        _this.smskey=res.data.data.smskey;
                        if (!_this.timer) {
                            _this.countsd = 60;
                            _this.codeShowd = false;
                            _this.timer = setInterval(() => {
                              if (_this.countsd > 0 && _this.countsd <= 60) {
                                _this.countsd--;
                              } else {
                                _this.codeShowd = true;
                                clearInterval(_this.timer);
                                _this.timer = null;
                              }
                            }, 1000)
                        }
                    }
                    else{
                        this.$Message.error(res.data.message)
                    }
                }).catch( function(response) {
                    console.log(response)
                });
            },
            //设置分成比列
            setBfbBtn(){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                if(_this.keyphone==''){
                    this.$Message.error('请输入验证手机号');
                    return false;
                }
                else if(pattern.test(_this.keyphone)==false){
                    this.$Message.error('验证手机号输错了');
                    return false;
                }
                else if(_this.smscode==''){
                    this.$Message.error('请输入验证码');
                    return false;
                }
                else if(_this.rate==''){
                    this.$Message.error('请设置分成比例');
                    return false;
                }
                else if(_this.rate < 0 || _this.rate > 100){
                    this.$Message.error('分成比例在0-100之间');
                    return false;
                }
                else{
                    _this.$axios.post('setincomeconfig',{
                        company_id:_this.company_id,
                        rate:_this.rate,
                        smscode:_this.smscode,
                        smskey:_this.smskey,
                        // password:_this.phopass
                    }).then(res=>{
                        if(res.data.code==200){
                            _this.setBfb=false;
                            _this.curRow.rate = _this.rate;
                            this.$Message.success('操作成功！');
                         }
                         else{
                            this.$Message.error(res.data.message);
                         }
                    }).catch(function (error) {
                      console.log(error);
                    });
                }
            },
            //获取收益列表
            getIncomeList(){
                let _this=this;
                _this.$axios.post('getcompanyincomelist',{
                    company_id:_this.company_id,
                    page:_this.incomePageNum,
                    start_date:_this.dateList[0],
                    end_date:_this.dateList[1]
                }).then(res=>{
                    if(res.data.code==200){
                        _this.incomePageTotal = res.data.data.total;
                        _this.incomeList    = res.data.data.list;
                    }else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //更新收益
            updateIncomePage(num=1) {
                let _this=this;
                _this.incomePageNum = num;
                if(_this.dateList == null ){
                    _this.dateList = ['',''];
                }
                _this.getIncomeList();
            },
            tychange(){
                let _this=this;
                if(!_this.is_stop){
                    this.$axios.post('changecompanystop',{
                        company_id:_this.company_id,
                    }).then(res=>{
                        if(res.data.code==200){
                            _this.data6=[];
                            _this.getCompanyList(0);
                            // _this.setShow=false;
                         }
                         else{
                            this.getCompanyList(0)
                            this.$Message.error(res.data.message);
                         }
                    }).catch(function (error) {
                      console.log(error);
                    });
                }
                else{
                    _this.stop_reason='';
                    this.$Modal.confirm({
                        render: (h) => {
                            return h('Input', {
                                props: {
                                    value: _this.stop_reason,
                                    autofocus: true,
                                    placeholder: '请输入停用原因'
                                },
                                style:{
                                    border:'1px solid #dcdcdc'
                                },
                                on: {
                                    input: (val) => {
                                        _this.stop_reason = val;
                                    }
                                }
                            })
                        },
                        onOk: () => {
                            if(_this.stop_reason==''){
                                this.$Message.error('请输入停用原因');
                            }
                            else{
                                this.$axios.post('changecompanystop',{
                                    company_id:_this.company_id,
                                    stop_reason:_this.stop_reason
                                }).then(res=>{
                                    if(res.data.code==200){
                                        _this.data6=[];
                                        _this.getCompanyList(0);
                                        // _this.setShow=false;
                                     }
                                     else{
                                        this.getCompanyList(0)
                                        this.$Message.error(res.data.message);
                                         // this.disabled=true;
                                     }
                                }).catch(function (error) {
                                  console.log(error);
                                });
                            }
                        },
                        onCancel: () => {
                            _this.stop_reason='';
                            _this.is_stop=false;
                        }
                    })
                }
            },
            sfchange(){
                let _this=this;
                this.$axios.post('changecompanypay',{
                    company_id:_this.company_id
                }).then(res=>{
                    if(res.data.code==200){
                        this.data6=[];
                        this.getCompanyList(0)
                        // this.$Message.success('操作成功');
                        // _this.setShow=false;
                     }
                     else{
                            this.$Message.error(res.data.message);
                         // this.disabled=true;
                            this.data6=[];
                            this.getCompanyList(0)
                     }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            tysure(){
                let _this=this;
                _this.setShow=false;
            },
            //点击上传图片事件
            doUpload(index){
                let _this = this;
                _this.clnum=index;
                if(index==1){
                    var files = document.getElementById('file1');
                    var fileLen = document.getElementById('file1').files;
                    var filename=$('#file1').val();
                    // _this.uploadByOss(fileLen[0])
                    // _this.option.autoCropWidth=241;//截图框宽
                    // _this.option.autoCropHeight=337;//截图框高
                    _this.option.img=URL.createObjectURL(fileLen[0]);
                    _this.cropShow=true;
                    // _this.imgd1=URL.createObjectURL(fileLen[0]);
                    $('#file1').val('')
                }
            },
            //图片地址
            upload(type){
                let _this=this;
                _this.$refs.cropper.getCropData((dataURL) => {
                    let base64 = dataURL.split(',')[1];
                    let fileType = dataURL.split(';')[0].split(':')[1];
                    let blob = this.toBlob(base64,fileType);
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    reader.onload = function (event) {
                        var file = new File([blob],new Date().getTime()+'.'+blob.type.split('/')[1],{type: "image/png"})
                        _this.uploadByOss(file)
                        if(_this.clnum==1){
                            _this.imgd1=dataURL;
                        }
                    }

                })
            },
            //裁剪弹窗隐藏
            delCrop(){
                this.cropShow=false;
            },
            //二进制转换
            toBlob(urlData,fileType){
                var bytes=window.atob(urlData),
                    n=bytes.length,
                    u8arr=new Uint8Array(n);
                while(n--){
                    u8arr[n]=bytes.charCodeAt(n);
                }
                return new Blob([u8arr],{type:fileType});
            },
            random_string(len) {
                len = len || 32;
                var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
                var maxPos = chars.length;
                var pwd = "";
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                } 
                return pwd;
            },
            //阿里云上传
            uploadByOss(file){
                let _this = this;
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var fileurl =new Date().getTime() + _this.random_string(16)+'.'+file.name.split('.')[1]
                return new Promise(function(resolve , reject){  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('policyaction').then(function(res){
                         var re = res.data.data;
                         var osssignature = {
                            'key' : re.dir+fileurl,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status' : '200', 
                            'signature': re.signature,
                            'callback':re.callback,
                        };
                        var formData = new FormData()
                        for( var k in osssignature ){
                            formData.append(k, osssignature[k])
                        }
                        //var suffix = _this.get_suffix(file.type); // 获取文件扩展名
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        //xhr.upload.addEventListener('progress', uploadProgress, false)
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
                                loading.close();
                                if(_this.clnum == 1){
                                    _this.addCompanyModel.logo = xhr.responseURL + re.dir + fileurl;
                                    _this.cropShow=false;
                                }
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }             
                    })
                })
            },   
            
            tandel(){
                this.alertShow=false;
            },
            tab(index,item){
                let _this=this;
                _this.num=index;
                _this.searchModel.is_stop=item.type;
                _this.searchModel.keyword='';

                _this.getCompanyList(1);
            },
            //获取承办单位列表
            getCompanyList(index){
                let _this=this;
                if(index==1){
                    _this.searchModel.page=1;
                }
                _this.$axios.post('getcompanylist',_this.searchModel).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.keyphone = res.data.data.phone;

                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.searchModel.page = num;
                this.getCompanyList(0);
            },
            //添加承办单位
            addCompany(){
                let _this  = this;
                _this.valm = 0;
                
                _this.addCompanyModel = {
                    company_id:"",
                    name:"",
                    province_id:'',
                    city_id:[],
                    address:'',
                    linkman:'',
                    linkphone:'',
                    email:'',
                    logo:'',
                    country_id:'',
                    type_id:'',
                    number:'',
                };
                _this.imgd1='';
                _this.alertShow=true;
            },
            //保存
            saveCompany(){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

                if(_this.addCompanyModel.type_id===''){
                    _this.$Message.error('请选择承办单位类型');
                }
                else if(_this.addCompanyModel.name==''){
                    _this.$Message.error('请输入'+_this.type_str+'名称');
                }

                else if((_this.type_str == '考级点' || _this.type_str == '教学点') && _this.addCompanyModel.number == ''){
                    _this.$Message.error('请输入'+_this.type_str+'编号');
                }

                else if(_this.addCompanyModel.country_id===''){
                    _this.$Message.error('请选择国家');
                }
                else if(_this.addCompanyModel.country_id=='754a7162vx84bd6v92c1'&&_this.addCompanyModel.province_id==''){
                    _this.$Message.error('请选择省份');
                }
                /*else if(_this.addCompanyModel.city_id==''){
                    this.$Message.error('请选择城市');
                }*/
                // else if(_this.addCompanyModel.address==''){
                //     _this.$Message.error('请输入详细地址');
                // }
                else if(_this.addCompanyModel.linkman==''){
                    _this.$Message.error('请输入联系人');
                }
                else if(_this.addCompanyModel.linkphone==''){
                    _this.$Message.error('请输入联系人手机');
                }
                else if(pattern.test(_this.addCompanyModel.linkphone)==false){
                    _this.$Message.error('联系人手机号输错了');
                }

                // else if((_this.type_str == '独家承办单位' || _this.type_str == '承办单位') && _this.addCompanyModel.email==''){
                //     _this.$Message.error('请输入邮箱');
                // }
                // else if((_this.type_str == '独家承办单位' || _this.type_str == '承办单位') && patternemail.test(_this.addCompanyModel.email)==false){
                //     _this.$Message.error('电子邮箱格式错误');
                // }
                else{
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let _url    = "";
                    if(_this.valm == 0){
                        _url    = "addcompany";
                    }else{
                        _url    = "editcompany";
                        _this.addCompanyModel.company_id = _this.company_id;
                    }
                    _this.$axios.post(_url,_this.addCompanyModel).then(res=>{
                        loading.close();
                        if(res.data.code==200){
                            _this.alertShow=false;
                            _this.getCompanyList(0);
                        }
                        else{
                            _this.$Message.error(res.data.message);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //获取省份列表
            getProvinceList(){
                let _this=this; 
                _this.$axios.post('getprovincelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.provinceArr=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //获取城市
            getCityList(){
                let _this=this; 
                _this.$axios.post('getcitylist',{
                    province_id:_this.addCompanyModel.province_id
                }).then(res=>{
                    if(res.data.code==200){
                        _this.cities=res.data.data;
                        _this.alertShow = true;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //获取国家
            getcountry(){
                let _this=this; 
                _this.$axios.post('getcountrylist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.countryList=res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //获取承办单位类型
            getCompanyType(){
                let _this=this; 
                _this.$axios.post('getcompanytype',{}).then(res=>{
                    if(res.data.code==200){
                        _this.companyTypeList = res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //获取星级
            getStarList(){
                let _this=this; 
                _this.$axios.post('getstarlist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.starList = res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },
        created(){
            let _this=this; 
            let luder = JSON.parse(localStorage.getItem("luder"));
            _this.getcountry();
            _this.getCompanyType();
            _this.getStarList();
            _this.getProvinceList();
            if(luder!=null){
                _this.searchModel = luder;
            }
            _this.getCompanyList();
        },
        watch: {
             "addCompanyModel.type_id": function (val, oldVal) {
                    for(var i in this.companyTypeList){
                        if (this.companyTypeList[i].id == this.addCompanyModel.type_id){
                            this.type_str = this.companyTypeList[i].name;
                            console.log(this.type_str);
                            if (this.type_str == '独家承办单位' || this.type_str == '承办单位'){
                                this.starShow = true;
                                this.numberShow = false;
                            }else{
                                this.starShow = false;
                                this.numberShow = true;
                            }
                        }
                    }
             }
             
        }
    }
</script>

<style scoped>
/**/
    .codeBtn{
        cursor:pointer;
        position: absolute;
        top: 2px;
        right: 0;
        width: 90px;
        height: 30px;
        background-color: #ffffff;
        border: solid 1px #dc4e5a;
        color: #dc4e5a;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
    }
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
    .add {
        width: 150px;
        height: 150px;
        float: left;
        cursor: pointer;
        background: url(../../../static/imgs/logoadd.png) no-repeat;  /*// 这里使用的是我本地图片*/
        background-size: 100% 100%;
    }
/**/
    /* .urlLogo{
        width: 150px;
        height: 210px;
        background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    } */
    .urlLogo1{
        width: 150px;
        height: 150px;
        border: solid 1px #e5e5e5;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 136px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 61px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 62px;
        line-height: 62px;
        border-bottom: 1px solid #e6e6e6;
        /*padding: 0 20px;*/
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/company/company.vue